import { render, staticRenderFns } from "./workersNumber.vue?vue&type=template&id=04dfefb9&scoped=true"
import script from "./workersNumber.vue?vue&type=script&lang=js"
export * from "./workersNumber.vue?vue&type=script&lang=js"
import style0 from "./workersNumber.vue?vue&type=style&index=0&id=04dfefb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfefb9",
  null
  
)

export default component.exports